module.exports = __webpack_public_path__ + "static/media/tick-check.c0583cea.png";